<template>
  <div class="radio">
    <div
      v-show="selected"
      @touchstart="selectItem(true)"
      class="fb fb-cross-center"
    >
      <i class="iconfont font-36 radio-color">&#xe66e;</i>
      <slot></slot>
    </div>
    <div
      v-show="!selected"
      @touchstart="selectItem(false)"
      class="fb fb-cross-center"
    >
      <i class="iconfont font-36 radio-unselect">&#xe66f;</i>
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    selected: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    selectItem(isSelected) {
      // eslint-disable-next-line vue/no-mutating-props
      this.selected = !this.selected
      this.$emit('radio', this.selected)
    }
  }
}
</script>
<style lang="scss" scoped>
.radio-color {
  color: #006afe;
}

.radio-unselect {
  color: rgba(25, 31, 37, 0.72);
}
</style>
